import { styled } from '@mui/material'
import CardContent from '@mui/material/CardContent'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { find, propEq } from 'ramda'
import React from 'react'

import SearchableSelect from '@/app/component/atom/form/searchable-select'
import TabHeader from '@/app/component/atom/tab-header'
import Loading from '@/app/component/guard/loading'
import { useGetCampaignOptions } from '@/app/module/campaigns/hooks/use-get-campaign-options'
import { useGetPhoneNumber } from '@/app/module/phonenumbers/hooks/use-get-phonenumber'
import { useUpatePhoneNumber } from '@/app/module/phonenumbers/hooks/use-update-phonenumber'
import { SelectOption } from '@/app/types'

type Props = {
  orgId: number
  phoneNumberId: number
  token: string
}

const CampaignHookTab: React.FC<Props> = ({ phoneNumberId }) => {
  const [data, setData] = React.useState<SelectOption<number>[]>([])
  const { data: phoneNumber } = useGetPhoneNumber(phoneNumberId)
  const [updatePhoneNumber, { isLoading }] = useUpatePhoneNumber()

  const {
    data: campaignIds,
    isFetching,
    refetch,
  } = useGetCampaignOptions({
    templates: 'ivr',
    page: 1,
    size: 100,
    aborted: false,
    archived: false,
  })

  const campaignId = phoneNumber?.inboundCallCampId
  const campaignData = phoneNumber?.inboundCallCamp

  React.useEffect(() => {
    if (campaignId && campaignData && campaignIds.length > 0 && !find(propEq('value', campaignId), campaignIds)) {
      setData([
        {
          label: `${campaignData.name} - ${campaignId}`,
          value: campaignId,
        },
        ...campaignIds,
      ])
    } else {
      setData(campaignIds)
    }
  }, [campaignIds, campaignData, campaignId])

  return (
    <Loading isLoading={isFetching || isLoading}>
      <TabHeader title="Incoming Voice Campaign" />
      <CardContent>
        <Typography variant="caption" sx={{ mb: 1, display: 'block' }}>
          Would you like us to pick up if someone is calling this number? If yes, choose a running and open Voice
          Campaign.
        </Typography>
        <div
          style={{
            margin: 'auto',
          }}
        >
          {!isFetching && (
            <div
              style={{
                display: 'flex',
                marginTop: '10px',
              }}
            >
              <div
                style={{
                  width: '400px',
                }}
              >
                <SearchableSelect
                  formControlProps={{
                    margin: 'none',
                  }}
                  helperText="Only the 100 most recent campaigns are shown."
                  id="phonenumbers-select-campaign"
                  label="Select Campaign"
                  labelId="select-campaign-label"
                  options={data}
                  showAll
                  value={campaignId || 0}
                  keyPropFn={(option) => option.value}
                  valuePropFn={(option) => option.label}
                  onChange={(selectedId) => {
                    updatePhoneNumber(phoneNumberId, {
                      inboundCallCampId: Number(selectedId) || 0,
                    })
                  }}
                />
              </div>
              <Tooltip id="reload-campaigns" title="Reload Campaign List">
                <ReloadButton onClick={() => refetch()}>
                  <Icon>refresh</Icon>
                </ReloadButton>
              </Tooltip>
            </div>
          )}
        </div>
      </CardContent>
    </Loading>
  )
}

export const ReloadButton = styled(IconButton)({
  marginTop: 15,
  height: 40,
})

export default CampaignHookTab
